import { memo } from 'react';
import { AppBar, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
// Local files
import { StyledToolbar } from './FlowsNavigation.styled';

const FlowsNavigation = () => {

  return (
    <AppBar sx={{flexDirection: 'column', justifyContent: 'center', height: 'calc(100% - 80px)', overflow: 'hidden'}} position='static' color='transparent' elevation={0}>
      <StyledToolbar>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl88a' >Appointment</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl99f' >Doc Fill Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl10e' >Esign Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl12v' >Voice Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl87e' >Waterfall Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl93t' >NYSJ reminders</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl29s' >Direct Ortho studies</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl04r' >Referral Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl54s' >Schedule Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl09c' >Confirm Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl30c' >Pen Study Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl19s' >Superbill Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl93b' >Book Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl71p' >Patient Flow</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl11s' >Flow 1</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl22n' >Flow 2</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl33b' >Flow 3</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl55d' >Flow 5</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl66p' >Flow 6</Button>
        <Button sx={{ minHeight: 44 }} fullWidth component={NavLink} to='/flow/fl77e' >Flow 7</Button>
      </StyledToolbar>
    </AppBar>
  );
};

export default memo(FlowsNavigation);